import { useAdStore } from '@/store/adStore';

/**
 * 提供渲染插屏广告服务 ("一次性"调用) 的组合式函数
 */
export function useInterstitialAd() {
  const adStore = useAdStore();
  const INTERSTITIAL_PLACEMENT_ID = adStore.INTERSTITIAL_PLACEMENT_ID;

  /**
   * 尝试获取并渲染一个插屏广告。
   * 如果成功渲染，会消耗掉该广告。
   * 如果没有可用广告，会尝试触发加载。
   * @returns {boolean} - 返回 true 如果成功渲染广告，否则返回 false。
   */
  const tryRenderInterstitialAd = () => {
    const adData = adStore.getNextAd(INTERSTITIAL_PLACEMENT_ID);

    if (adData) {
      console.log("[useInterstitialAd] Found ad data, attempting to render...");
      try {
        // 调用 SDK 的渲染方法
        if (window.TencentGDT && window.TencentGDT.NATIVE && typeof window.TencentGDT.NATIVE.renderAd === 'function') {
            window.TencentGDT.NATIVE.renderAd(adData);
            // 消耗掉已使用的广告
            adStore.consumeAd(INTERSTITIAL_PLACEMENT_ID);
            console.log("[useInterstitialAd] Ad rendered successfully.");
            return true; // 渲染成功
        } else {
            console.error("[useInterstitialAd] TencentGDT.NATIVE.renderAd is not available.");
            return false; // 渲染失败 (SDK 问题)
        }
      } catch (error) {
        console.error("[useInterstitialAd] Error rendering ad:", error);
        // 如果渲染失败，也消耗掉这条广告数据，避免无限重试同一个错误的广告
         adStore.consumeAd(INTERSTITIAL_PLACEMENT_ID);
         return false; // 渲染失败 (执行异常)
      }
    } else {
      console.log("[useInterstitialAd] No ad data available in queue. Attempting to load more...");
      // 如果队列为空，尝试加载更多广告 (检查是否已在加载中)
      if (!adStore.checkIsLoading(INTERSTITIAL_PLACEMENT_ID)) {
        adStore.loadAds(INTERSTITIAL_PLACEMENT_ID);
      }
      return false; // 当前无广告可渲染
    }
  };

  // 暴露核心的渲染触发函数
  return {
    tryRenderInterstitialAd
  };
} 